import React from 'react';
import PropTypes from 'prop-types';
import { Dialog, DialogTitle, DialogContent, Box, Typography, IconButton, CircularProgress } from '@mui/material';
import Grid from '@mui/material/Grid2';
import CloseIcon from '@mui/icons-material/Close';
import M from 'messages';
import classes from './styles';

const TemplateImageModal = ({
  open,
  onClose,
  onSelect,
  templates = [],
  title,
  loading = false,
  isLandscape = true,
}) => {
  const handleSelect = template => {
    onSelect(template);
    onClose();
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle>
        <Box display="flex" justifyContent="space-between" alignItems="center">
          <Typography variant="h6">{title || M.get('menuItem.templateModal.title')}</Typography>
          <IconButton onClick={onClose} size="small">
            <CloseIcon />
          </IconButton>
        </Box>
      </DialogTitle>
      <DialogContent>
        {loading ? (
          <Box sx={classes.loadingState}>
            <CircularProgress />
            <Typography sx={classes.loadingText}>{M.get('menuItem.templateModal.loading')}</Typography>
          </Box>
        ) : (
          <Grid container spacing={2} sx={classes.gridContainer}>
            {templates.length === 0 ? (
              <Box sx={classes.emptyState}>
                <Typography>{M.get('menuItem.templateModal.noTemplates')}</Typography>
              </Box>
            ) : (
              templates.map((template, index) => (
                <Grid key={index} size={{ xs: 12, sm: 6, md: 4 }}>
                  <Box
                    sx={classes.templateItem}
                    onClick={() => handleSelect(template)}
                    role="button"
                    tabIndex={0}
                    onKeyDown={e => {
                      if (e.key === 'Enter' || e.key === ' ') {
                        e.preventDefault();
                        handleSelect(template);
                      }
                    }}>
                    <Box
                      component="img"
                      src={template.url || template}
                      alt={template.alt || `Template ${index + 1}`}
                      sx={{ ...classes.templateImage, objectFit: isLandscape ? 'cover' : 'contain' }}
                    />
                    {template.label && (
                      <Typography variant="caption" sx={classes.templateLabel}>
                        {template.label}
                      </Typography>
                    )}
                  </Box>
                </Grid>
              ))
            )}
          </Grid>
        )}
      </DialogContent>
    </Dialog>
  );
};

TemplateImageModal.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onSelect: PropTypes.func.isRequired,
  templates: PropTypes.arrayOf(
    PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.shape({
        url: PropTypes.string.isRequired,
        alt: PropTypes.string,
        label: PropTypes.string,
      }),
    ]),
  ),
  title: PropTypes.string,
  loading: PropTypes.bool,
  isLandscape: PropTypes.bool,
};

export default TemplateImageModal;
